import '@fortawesome/fontawesome-free/css/all.css' 
import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#2364AA',
        accent: '#c86d0b',
        info: '#0496ff',
        error: '#DD1C1A',
        warning: '#F08307',
        success: '#4DAA14',
        background: '#0081e0'
      }
    }
  },
  icons: {
    iconfont: 'mdi' || 'fa'
  }
});
